module.exports = {
  social_deduction_games_online: {
    title: 'Trò chơi suy luận xã hội cho bạn bè | Avalon',
    description:
      'So sánh bốn trò cho 5–10 người bạn: chơi trên trình duyệt hay cài đặt, bỏ phiếu và loại người chơi. Thử Avalon một mình với bot.',
    keywords: ['trò chơi suy luận xã hội'],
    breadcrumbs: [
      {
        to: '/vi/',
        title: 'Trang chủ',
      },
      {
        to: '/vi/guides/social-deduction-games-online/',
        title: 'Trò chơi suy luận xã hội',
      },
    ],
  },
  games_like_secret_hitler: {
    title: 'Trò chơi giống Secret Hitler: thử Avalon',
    description:
      'So sánh Secret Hitler với Avalon: phe ẩn, bỏ phiếu và thẻ Nhiệm vụ. Chơi cùng bạn bè hoặc học cách chơi Avalon với bot.',
    keywords: ['trò chơi giống Secret Hitler'],
    breadcrumbs: [
      {
        to: '/vi/',
        title: 'Trang chủ',
      },
      {
        to: '/vi/guides/social-deduction-games-online/',
        title: 'Trò chơi suy luận xã hội',
      },
      {
        to: '/vi/guides/games-like-secret-hitler/',
        title: 'Trò chơi giống Secret Hitler',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: 'Trò chơi giống Ma Sói và Mafia: Avalon',
    description:
      'So sánh cơ chế loại người chơi, vai trò và bỏ phiếu trong Avalon, Ma Sói, Mafia. Thử Avalon online trên trình duyệt cùng bạn bè hoặc bot.',
    keywords: ['trò chơi giống Ma Sói'],
    breadcrumbs: [
      {
        to: '/vi/',
        title: 'Trang chủ',
      },
      {
        to: '/vi/guides/social-deduction-games-online/',
        title: 'Trò chơi suy luận xã hội',
      },
      {
        to: '/vi/guides/avalon-vs-werewolf/',
        title: 'Avalon và Ma Sói',
      },
    ],
  },
};
